import { render, staticRenderFns } from "./PasswordRecoveryC.vue?vue&type=template&id=8c6a0dbe"
import script from "./PasswordRecoveryC.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryC.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecoveryC.vue?vue&type=style&index=0&id=8c6a0dbe&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports